// extracted by mini-css-extract-plugin
export var active = "_ic-2";
export var recordingDot = "_ic-1";
export var recordingIndicator = "_ic-0";